<template>
  <div class="flex">
    <!-- Big sparkle -->
    <svg class="mt-1 sparkle sparkle-big sparkle-delay-1" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.6667 2L11.2167 8.21207C10.9035 9.00617 10.7469 9.40317 10.5071 9.73797C10.2946 10.0348 10.0347 10.2946 9.738 10.5072C9.4032 10.7469 9.0061 10.9035 8.212 11.2167L2 13.6667L8.212 16.1167C9.0061 16.4299 9.4032 16.5865 9.738 16.8262C10.0347 17.0388 10.2946 17.2986 10.5071 17.5954C10.7469 17.9302 10.9035 18.3272 11.2167 19.1213L13.6667 25.3334L16.1167 19.1213C16.4298 18.3272 16.5864 17.9302 16.8262 17.5954C17.0388 17.2986 17.2986 17.0388 17.5954 16.8262C17.9302 16.5865 18.3272 16.4299 19.1213 16.1167L25.3333 13.6667L19.1213 11.2167C18.3272 10.9035 17.9302 10.7469 17.5954 10.5072C17.2986 10.2946 17.0388 10.0348 16.8262 9.73797C16.5864 9.40317 16.4298 9.00617 16.1167 8.21207L13.6667 2Z"
        stroke="#FF8300"
        stroke-width="2.96296"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>

    <!-- Small sparkles -->
    <div class="flex flex-col content-between justify-between gap-3 -ml-1">
      <svg class="sparkle sparkle-small sparkle-delay-2" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.3334 2V8.6667M2 5.33333H8.6667" stroke="#FF8300" stroke-width="2.96296" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <svg class="sparkle sparkle-small sparkle-delay-3" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.3334 2V8.6667M2 5.33333H8.6667" stroke="#FF8300" stroke-width="2.96296" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
  </div>
</template>

<style scoped>
@keyframes sparkle {
  0% {
    transform: scale(1);
  }
  33.3% {
    transform: scale(0.75);
  }
  66.66% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}

.sparkle {
  animation: sparkle 0.8s ease-in-out;
}

.sparkle-big {
  width: 1.6875rem;
  height: 1.6875rem;
}

.sparkle-small {
  width: 0.6875rem;
  height: 0.6875rem;
}

.sparkle-delay-1 {
  animation-delay: 1s;
}
.sparkle-delay-2 {
  animation-delay: 1.2s;
}
.sparkle-delay-3 {
  animation-delay: 1.6s;
}
</style>
